import { Receipt } from "@/types/receipt";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { newCustomerCleanup } from "../actions";

interface ReceiptState {
  current: Receipt | undefined;
  isPaid: boolean;
}

const getInitialState = (): ReceiptState => ({
  current: undefined,
  isPaid: false,
});

const receiptSlice = createSlice({
  name: "receipt",
  initialState: getInitialState(),
  reducers: {
    setPaid: (state) => {
      state.isPaid = true;
    },
    setCurrentReceipt: (state, { payload }: PayloadAction<Receipt>) => {
      state.current = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(newCustomerCleanup, () => getInitialState());
  },
});

export const { setPaid, setCurrentReceipt } = receiptSlice.actions;

export default receiptSlice.reducer;
